export function buildReducer(initialState, actionMap) {
  return function reducer(state = initialState, action) {
    if (actionMap[action.type]) {
      return actionMap[action.type](state, action)
    }
    return state
  }
}
